import React from 'react';
import Menu404 from './Menu404';
import SideNav from '../element/nav/SideNav';
import navConfig from '../element/nav/navConfig';
import dataSuper from '../hooks/Conf';
import dataFinzas from '../hooks/useFinzas';
import dataDireccionEstudiantil from '../hooks/useDireccionEstudiantil';

// Selecciona la navegación según el rol del usuario.
// La estructura de cada perfil vive en element/nav/navConfig.js.
const Menu = () => {
    let datos = localStorage.getItem('dataUser');

    if (datos) {
        let cred = JSON.parse(datos);
        if (cred.perfil === 'Alumnos' || cred.perfil === 'Estudiante') {
            return <SideNav sections={navConfig.alumnos} />;
        } else if (dataSuper.indexOf(cred.carnet.trim()) !== -1) {
            return <SideNav sections={navConfig.superadmin} />;
        } else if (dataFinzas.indexOf(cred.carnet.trim()) !== -1) {
            return <SideNav sections={navConfig.finanzas} />;
        } else if (dataDireccionEstudiantil.indexOf(cred.carnet.trim()) !== -1) {
            return <SideNav sections={navConfig.direccionestudiantil} />;
        } else if (cred.perfil === 'Profesores' || cred.perfil === 'Decanos' || cred.perfil === 'Administrativo' || cred.perfil === 'Docente') {
            return <SideNav sections={navConfig.admin} />;
        } else {
            return <Menu404 />;
        }
    } else {
        return <Menu404 />;
    }
}

export default Menu
